import {
  useCreateUser,
  useUpdateUser,
} from '@/core/domain/enterprise/Users/Users.hooks';
import {
  UserFormValues,
  UserReduced,
} from '@/core/domain/enterprise/Users/Users.types';
import { Form, Modal, ModalProps } from 'antd';
import { useEffect } from 'react';
import UserForm from '../UserForm';

type Props = Omit<ModalProps, 'onCancel'> & {
  user?: UserReduced;
  onCancel: VoidFunction;
};

const UserModalForm: React.FC<Props> = ({ user, ...props }) => {
  const [form] = Form.useForm<UserFormValues>();

  const userCreate = useCreateUser();
  const userUpdate = useUpdateUser();

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        email: user.email,
        login: user.login,
        profileId: user?.profileId,
        employeeId: user.employeeId,
      });
    }
  }, [user]);

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      if (user) {
        await userUpdate.mutateAsync({
          ...values,
          profilesId: [values.profileId],
          id: user.id,
        });
      } else {
        await userCreate.mutateAsync({
          ...values,
          profilesId: [values.profileId],
        });
      }
      handleClose();
    } catch {}
  }

  function handleClose() {
    if (props.onCancel) {
      props.onCancel();
    }
    form.resetFields();
  }

  return (
    <Modal
      {...props}
      onCancel={handleClose}
      onOk={handleSubmit}
      title={`${user ? 'Edição' : 'Cadastro'} de usuário`}
      okText="Salvar"
      confirmLoading={userCreate.isLoading || userUpdate.isLoading}
    >
      <UserForm form={form} isEdit={!!user} />
    </Modal>
  );
};

export default UserModalForm;
